import { useSearchParams } from 'next/navigation'

import { type Locale, usePathname, useRouter } from '@/shared/i18n'
import { cn } from '@/shared/lib'
import { Select } from '@/shared/ui'

const MOBILE_WIDTH = 140
const DESKTOP_TRIGGER_WIDTH = 36
const DESKTOP_WIDTH = 101

type Props = {
  isMobile: boolean
  locale: Locale
  className?: string
}

export const LocaleSelector = ({ isMobile, locale, className }: Props) => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const router = useRouter()

  const handleLocaleChange = (value: Locale) => {
    const searchParamsString = searchParams?.toString()
    const currentPath = `${pathname}${searchParamsString ? `?${searchParamsString}` : ''}`

    router.replace(currentPath, { locale: value })
  }

  const options: {
    label: string
    display: string
    value: Locale
  }[] = [
    {
      label: 'KR(한국어)',
      display: 'KR',
      value: 'ko',
    },
    {
      label: 'EN(영어)',
      display: 'EN',
      value: 'en',
    },
  ]

  const localeLabel = (() => {
    const option = options.find(option => option.value === locale)

    return isMobile ? option?.label : option?.display
  })()

  return (
    <Select.Root
      mode="menu"
      size="small"
      width={isMobile ? MOBILE_WIDTH : DESKTOP_TRIGGER_WIDTH}
      value={locale}
      onValueChange={handleLocaleChange}
    >
      <Select.Trigger variant={isMobile ? 'box' : 'text'} className={className}>
        {localeLabel}
      </Select.Trigger>
      <Select.Content
        variant={isMobile ? 'box' : 'text'}
        shadow={!isMobile}
        className={cn(
          isMobile ? `w-[${MOBILE_WIDTH}px]` : `w-[${DESKTOP_WIDTH}px]`,
        )}
      >
        {options.map(option => (
          <Select.Item key={option.value} value={option.value}>
            {option.label}
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  )
}
